import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ClassIcon from '@mui/icons-material/Class';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import SchoolSettings from '../school-admin/SchoolSettings';
import UserManagement from '../school-admin/UserManagement';

// Placeholder components for school admin routes
const SchoolAdminDashboard = () => <div>School Admin Dashboard - Coming Soon</div>;
const ClassManagement = () => <div>Class Management - Coming Soon</div>;
const LessonOverview = () => <div>Lesson Overview - Coming Soon</div>;
const SchoolReports = () => <div>School Reports - Coming Soon</div>;

/**
 * SchoolAdminLayout component for school administrators
 * Provides navigation and routes for school-level management features
 */
const SchoolAdminLayout: React.FC = () => {
  const navigationItems = [
    {
      label: 'Dashboard',
      path: '/school-admin/dashboard',
      icon: <DashboardIcon />,
    },
    {
      label: 'Users',
      path: '/school-admin/users',
      icon: <PeopleIcon />,
    },
    {
      label: 'Classes',
      path: '/school-admin/classes',
      icon: <ClassIcon />,
    },
    {
      label: 'Lessons',
      path: '/school-admin/lessons',
      icon: <AssignmentIcon />,
    },
    {
      label: 'Reports',
      path: '/school-admin/reports',
      icon: <BarChartIcon />,
    },
    {
      label: 'Settings',
      path: '/school-admin/settings',
      icon: <SettingsIcon />,
    },
  ];

  return (
    <BaseLayout title="School Administration" navigationItems={navigationItems}>
      <Routes>
        <Route path="dashboard" element={<SchoolAdminDashboard />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="classes" element={<ClassManagement />} />
        <Route path="lessons" element={<LessonOverview />} />
        <Route path="reports" element={<SchoolReports />} />
        <Route path="settings" element={<SchoolSettings />} />
        <Route path="/" element={<Navigate to="/school-admin/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/school-admin/dashboard" replace />} />
      </Routes>
    </BaseLayout>
  );
};

export default SchoolAdminLayout;
